import { AnyAction } from 'redux';

export interface Action<TType extends string = any, TPayload = any> extends AnyAction {
    readonly type: TType;
    payload: TPayload;
}

export interface ActionCreator<TAction extends Action> {
    (payload: TAction['payload']): TAction;
}

export interface ProjectFunction<TAction extends Action> {
    (input?: any): TAction['payload'];
}

export function identity<T>(input: T): T {
    return input;
}
/**
 * Creates an action creator function for a given action type
 *
 * @export
 * @template TAction the action interface
 * @param {TAction['type']} type the action type string
 * @param {ProjectFunction<TAction>} [project=identity] optional function for transforming the payload
 * @returns {ActionCreator<TAction>} a function that accepts a payload and returns an action object
 */
export function createAction<TAction extends Action>(
    type: TAction['type'],
    project: ProjectFunction<TAction> = identity,
): ActionCreator<TAction> {
    if (typeof type !== 'string') {
        throw new TypeError(`Unexpected type ${typeof type}, expected 'string'`);
    }

    if (typeof project !== 'function') {
        throw new TypeError(`Unexpected type ${typeof project}, expected 'function'`);
    }

    return <P = TAction['payload']>(payload: any) => ({
        type,
        payload: project(payload),
    } as TAction);
}
